import React, { useEffect } from 'react'
import { FlagsIconSeeker, SelectSeeker } from "@ui-seeker/core"
import { Box, Typography } from "@mui/material"
import { sitesModalData } from "@signals"
import { translateCountryName } from "@ui-seeker/utils"

export default function ModalCountriesSelector({ applyFilters, countriesOptions, onChangeCountry }) {

	const options = Array.from(new Set(sitesModalData.value.map(({ market }) => market))).map(market => ({
		value: market,
		label: (
			<Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start", gap: .5 }}>
				<FlagsIconSeeker countryName={market}/>
				<Typography>{translateCountryName(market)}</Typography>
			</Box>
		)
	}))

	useEffect(() => {
		applyFilters()
	}, [countriesOptions])

	return <SelectSeeker
		multiple
		label="Filter site country"
		placeholder="All countries"
		value={countriesOptions}
		onChange={onChangeCountry}
		isClearable
		options={options}
	/>
}